// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.87.0',
  revision: '4bc7d696',
  branch: 'master',
  date: 'Thu, 26 Mar 2026 11:07:19 GMT'
};